import { render } from "./RegisterInfo.vue?vue&type=template&id=8f0c6094"
const script = {}

import exportComponent from "/home/runner/work/app-registration/app-registration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__